import { pick } from '@eastcoal/common/utils/object'

import { useRichEditorStore } from '../../Store/hooks/useStore'
import { $setSelectionStyle } from '../../utils/style'
import { useEditor } from '../useEditor'

export const useFontColor = () => {
  const editor = useEditor()
  const { defaultFontColor, currentFontColor, setCurrentFontColor } =
    useRichEditorStore(state =>
      pick(state, [
        'defaultFontColor',
        'currentFontColor',
        'setCurrentFontColor'
      ])
    )

  return {
    defaultFontColor,
    fontColor: currentFontColor,
    setFontColor: (value: string) => {
      $setSelectionStyle(editor, { color: value })
      setCurrentFontColor(value)
    },
    toggleFontColor: () => {
      $setSelectionStyle(editor, { color: currentFontColor })
    }
  }
}
